import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 144px)',
      overflowY: 'scroll',
    },
    card: {
      padding: '12px',
    },
    fileMessage: {
      padding: '16px',
      color: 'rgba(255, 255, 255, .60)',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      left: '50%',
      position: 'absolute',
      transform: 'translateX(-50%)',
    },
    actionDiv: {
      '& .actionGrid': {
        padding: 5,
      },
    },
    workPackageFilesDocumentDiv: {
      '& .workPackageFilesDocumentCard': {
        padding: 8,
      },
      '& .workPackageFilesDocumentCardInner': {
        padding: 16,
      },

      '& #openPrivewDiv': {
        cursor: 'pointer',
      },
      '& #typographyFileName': {
        fontSize: 24,
        color: 'rgba(255,255,255,0.87)',
        fontWeight: 300,
        verticalAlign: 'center',
        display: 'flex',
      },
      '& .typographyFileNameInner': {
        fontSize: 24,
        fontWeight: 300,
      },
    },
    cardGrid: {
      padding: 8,
    },
  }),
);

export default useStyles;
